import LinkIcon from '@mui/icons-material/Link';
import { PatientActions } from 'apps/wrapper/src/components/shared/contact/patient-actions/patient-actions';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus/use-event-bus';
import { Contact } from 'apps/wrapper/src/services/api-client/contact-api';
import { AppointmentRequestDetails } from 'apps/wrapper/src/services/appointment/types/appointment-request-details';
import { formatPhoneNumber } from 'apps/wrapper/src/utils/formatter';
import moment from 'moment';
import { FC } from 'react';
import { EventPatientProfile } from '../../../../../../types/event-bus';
import { useApptRequestsWidget } from '../../hooks/use-appt-requests-widget';
import {
  GeneralPatientInfoBlock,
  GeneralPatientInfoBlockWrapper,
  PatientActionsWrapper,
  PatientEmail,
  PatientInfoList,
  PatientInfoListItem,
  PatientName,
  PatientNameButton
} from './general-patient-info.styles';
import { CreatePatientActionsProps } from './utils/create-patient-actions-props';

export interface GeneralPatientInfoProps {
  requestDetails: AppointmentRequestDetails;
  contact: Contact | undefined;
}

export const GeneralPatientInfo: FC<GeneralPatientInfoProps> = (props) => {
  const { publish } = useEventBus();
  const { requestDetails, contact } = props;
  const { locationId, locationName } = useApptRequestsWidget();
  const patientActionsContact = CreatePatientActionsProps(requestDetails, locationId, locationName, contact);

  const getPhoneNumber = (phone?: string) => {
    if (!phone) return 'no phone';

    const isFormatted = phone.includes('(') && phone.includes(')') && phone.includes('-');

    return isFormatted ? phone : formatPhoneNumber(phone);
  };

  const patientNameClick = (patient: { id?: number }) => {
    publish({
      messageType: 'patientProfile',
      data: { patientId: patient.id } as EventPatientProfile['data']
    });
  };

  const formatDateOfBirth = () => {
    const dob = contact?.dateOfBirth || requestDetails.patient.birthdate;
    if (!dob) return 'no date of birth';

    const m = moment(dob);
    return m.isValid() ? m.format('MM/DD/YYYY') : 'no date of birth';
  };

  return (
    <GeneralPatientInfoBlockWrapper>
      <GeneralPatientInfoBlock>
        {requestDetails.patient.id && contact?.isPatientPreferencesAvailable ? (
          <PatientNameButton variant="text" onClick={() => patientNameClick(requestDetails.patient)} disableRipple>
            {contact ? contact.firstName : requestDetails.patient.firstName}{' '}
            {contact ? contact.lastName : requestDetails.patient.lastName}
            <LinkIcon sx={{ color: '#008A06', width: '20px', marginLeft: '8px' }} />
          </PatientNameButton>
        ) : (
          <PatientName>
            {contact ? contact.firstName : requestDetails.patient.firstName}{' '}
            {contact ? contact.lastName : requestDetails.patient.lastName}
          </PatientName>
        )}
        <PatientInfoList>
          <PatientInfoListItem>{formatDateOfBirth()}</PatientInfoListItem>
          <PatientInfoListItem>{getPhoneNumber(requestDetails.patient.phone)}</PatientInfoListItem>
        </PatientInfoList>
        <PatientEmail>{requestDetails.patient.email ? requestDetails.patient.email : 'no email'}</PatientEmail>
      </GeneralPatientInfoBlock>
      <PatientActionsWrapper>
        <PatientActions locationId={locationId} contact={patientActionsContact} />
      </PatientActionsWrapper>
    </GeneralPatientInfoBlockWrapper>
  );
};
